import { DeviceEventEmitter } from 'react-native';

import type { EmitterSubscription } from 'react-native';

/**
 * In-app signal that a `projectUpdated` subscription payload arrived (TA-11139).
 *
 * The backend publishes `projectUpdated` to every member of a project when one
 * of its tasks is created, completed, updated, deleted or (re)assigned
 * (ProjectUpdatedSubscriptionJob). The app holds exactly one subscription to
 * it, in useProjectMemberAddedNotification, so that hook re-broadcasts each
 * payload here and My Tasks refreshes on it instead of polling on a timer.
 */
const PROJECT_UPDATED_EVENT = 'TASKTAG_PROJECT_UPDATED';

/**
 * Called without a project id after the socket reconnects: payloads may have
 * been missed while it was down (TA-11139).
 */
export const emitProjectUpdated = (projectId?: string) => {
  DeviceEventEmitter.emit(PROJECT_UPDATED_EVENT, projectId);
};

export const addProjectUpdatedListener = (
  listener: (projectId: string | undefined) => void
): EmitterSubscription =>
  DeviceEventEmitter.addListener(PROJECT_UPDATED_EVENT, listener);
